import React, { useReducer, useEffect } from "react";
import {
  Col,
  Row,
  Accordion,
  Image,
  Button,
  Alert,
  Card,
  Badge,
} from "react-bootstrap";
import StatsListing from "../shared/infoListing/StatsListing";
import ActivityRecentRegistrations from "../../modules/activities/partials/details/ActivityRecentRegistrations";
import memberDummyImage from "../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../images/memberStatusMember.jpg";
import accountDeleted from "../../../images/accountDelete.png";
import ModuleDisplayDateTime from "../modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayBoolean from "../modules/fieldsDisplay/ModuleDisplayBoolean";
import { getFullName } from "../../../../src/helpers/CommonHelper";
import { PieChart } from 'react-minimal-pie-chart';
import { FaUserCheck } from "react-icons/fa6";
import { FaUserClock } from "react-icons/fa";
import { LiaUserPlusSolid } from "react-icons/lia";
import { HiCurrencyDollar } from "react-icons/hi2";
import { FaUserLargeSlash } from "react-icons/fa6";
import { MdCarCrash } from "react-icons/md";
import { RiUserStarFill } from "react-icons/ri";
import { FcExpired } from "react-icons/fc";
import { FaUser } from "react-icons/fa6";
import { FaUserPlus } from "react-icons/fa6";
import { PiUserCircleGearBold } from "react-icons/pi";
import {
  dashboardInitialState,
  dashboardReducer,
} from "../../modules/activities/reducers/dashboardReducer";
import axiosInstance from "../../../config/axios";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import { Link, useNavigate } from "react-router-dom";
function MemberContent() {
  const [detailsState, detailsDispatch] = useReducer(
    dashboardReducer,
    dashboardInitialState
  );
  const navigate = useNavigate();

  const handleClick = (role) => {

    navigate(`/members?${role}`);

  };
  const handleNavigate = (url) => {

    navigate(url);

  };
  const loadItem = async () => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });
    try {
      const res = await axiosInstance.get(`members/stats-for-dashboard`);
      detailsDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };
  useEffect(() => {
    loadItem();
  }, []);

  return (
    <>
      {detailsState.isFetching == true && <FullPageOverlay />}
      {detailsState.data && detailsState.data.summary && (
        <>
          <Card className="mt-xl-0 mt-lg-0 mt-md-0 mt-2 mb-xl-0 mb-lg-0 mb-md-0 border-themePrimary">
            <Card.Body className="p-xl-2 p-lg-2 p-md-2 p-0">
              <Row className="showOnMobile bg-themePrimary text-center w-100 mx-auto">
                <Col>
                  <h5 className="my-3 px-1 text-bold text-themePrimary">
                    Members
                  </h5>
                </Col>
              </Row>
              <Row className="w-100 mx-auto">
                <Col>
                  <Row className="mt-xl-3 mt-lg-3 mt-md-3 mt-1 px-1 ">
                    {detailsState.data?.summary && detailsState.data?.summary?.signupRequests && <>

                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=signupRequests")}>
                        <a

                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box bg-linear-four">
                            <div class="dashboard-box-icon">
                              <FaUserPlus />
                            </div>

                            <div>
                              <h5 class="dashboard-box-heading d-flex flex-column">
                                <span className="fs-5 font-weight-bold mb-1">
                                  {
                                    detailsState.data?.summary?.signupRequests.total

                                  }
                                </span>{" "}
                                Total Signup Request(s)
                              </h5>
                            </div>

                          </div>
                        </a>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=SignupRequest")}>
                        <a

                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box action bg-linear-one">
                            <div class="dashboard-box-icon">
                              <FaUserPlus />
                            </div>
                            <div>
                              {detailsState.data.summary.signupRequests.adminActionRequired > 0 ? (
                                <h5 class="dashboard-box-heading d-flex flex-column">
                                  <span className="fs-5 font-weight-bold mb-0">
                                    {detailsState.data.summary.signupRequests.adminActionRequired}
                                  </span>{" "}
                                  Pending Signup Request(s)
                                </h5>
                              ) : (
                                <h5 class="dashboard-box-heading">
                                  No Pending signup request(s)
                                </h5>
                              )}
                              {detailsState.data.summary.signupRequests.adminActionRequired > 0 &&
                                <p className="mb-0 text-white fontBoldItalic fs-12 text-center heartbeat">Admin Action Required</p>}
                            </div>

                            <div>
                              <p className="text-white font-small action">
                                Action:{" "}
                                <b>{process.env.REACT_APP_WEBSITE_NAME} Admin</b>
                              </p>
                            </div>
                          </div>
                        </a>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=RegistrationPaymentPending")}>
                        <a
                          href="/members?status=RegistrationPaymentPending"
                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box action bg-linear-two">
                            <div class="dashboard-box-icon">
                              <HiCurrencyDollar />
                            </div>

                            <div>
                              <h5 class="dashboard-box-heading d-flex flex-column">
                                <span className="fs-5 font-weight-bold mb-1">
                                  {detailsState.data.summary.signupRequests.SignupPaymentPending}
                                </span>{" "}
                                Signup Payment Pending
                              </h5>
                            </div>
                            <div>
                              <p className="text-white font-small action">
                                Action: <b>Member</b>
                              </p>
                            </div>
                          </div>
                        </a>
                      </Col>
                    </>}
                    {/* <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1">
                      <a
                        href="/members?status=EmailVerificationRequired"
                        className="d-flex h-100 w-100"
                      >
                        <div class="dashboard-box action bg-linear-two">
                          <div class="dashboard-box-icon">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                          </div>

                          <div>
                            <h5 class="dashboard-box-heading d-flex flex-column">
                              <span className="fs-5 font-weight-bold mb-1">
                                {
                                  detailsState.data.summary
                                    .emailVerificationRequired
                                }
                              </span>{" "}
                              Pending Email Verification(s)
                            </h5>
                          </div>
                          <div>
                            <p className="text-white font-small action">
                              Action: <b>Member</b>
                            </p>
                          </div>
                        </div>
                      </a>
                    </Col> */}
                    {detailsState.data?.summary && detailsState.data?.summary?.members && <>
                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=all")}>
                        <a

                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box bg-linear-eleven">
                            <div class="dashboard-box-icon">
                              <FaUser />
                            </div>

                            <div>
                              <h5 class="dashboard-box-heading d-flex flex-column">
                                <span className="fs-5 font-weight-bold mb-1">
                                  {
                                    detailsState.data.summary
                                      .members.total

                                  }
                                </span>{" "}
                                Total Members
                              </h5>
                            </div>

                          </div>
                        </a>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=ActiveMembers")}>
                        <a

                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box bg-linear-three">
                            <div class="dashboard-box-icon">
                              <FaUserCheck className="" />
                            </div>

                            <div>

                              <h5 class="dashboard-box-heading d-flex flex-column ">
                                <span className="fs-5 font-weight-bold mb-1 ">
                                  {
                                    detailsState.data.summary
                                      .members.activeMembers

                                  }
                                </span>{" "}
                                Active Member(s)
                              </h5>

                            </div>
                          </div>
                        </a>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=inactiveMembers")}>
                        <a
                          href="/members?status=inactiveMembers"
                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box bg-linear-light-yellow text-warning">
                            <div class="dashboard-box-icon text-warning">
                              <FaUserClock />
                            </div>

                            <div>
                              <h5 class="dashboard-box-heading d-flex flex-column text-warning">
                                <span className="fs-5 font-weight-bold mb-1 ">
                                  {
                                    detailsState.data.summary
                                      .members.inactiveMembers

                                  }
                                </span>{" "}
                                Inactive Members
                              </h5>
                            </div>
                            {/* <div>
                          <p className="text-white font-small action">
                            Action: <b>Admin</b>
                          </p>
                        </div> */}
                          </div>
                        </a>
                      </Col>

                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" >
                        <a

                          className="d-flex h-100 w-100"
                        >
                          <div class="dashboard-box action bg-linear-red">
                            <div class="dashboard-box-icon">
                              <i class="fa fa-hourglass-end"></i>
                            </div>

                            <div onClick={() => handleNavigate("/members?status=ExpiredMembers")}>
                              <h5 class="dashboard-box-heading d-flex flex-column">
                                <span className="fs-5 font-weight-bold mb-0">
                                  {detailsState.data.summary.members.expiredMembers}
                                </span>{" "}
                                Total Membership(s) Expired
                              </h5>
                            </div>
                            <div>
                              <p className="text-white font-small action">
                                Action: <b>Member</b>
                              </p>
                            </div>
                            {detailsState.data.summary.members.expiredMembersThisYear > 0 &&
                              <p className="mb-0 text-white fontItalic fs-12 text-center" onClick={() => handleNavigate("/members?status=thisYear")}>Membership(s) expired this year: <b className="text-white">{detailsState.data.summary.members.expiredMembersThisYear}</b> </p>}
                          </div>
                        </a>
                      </Col>

                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=RenewedMembers")}>
                        <a className="d-flex h-100 w-100">
                          <div class="dashboard-box bg-linear-six">
                            <div class="dashboard-box-icon">
                              <PiUserCircleGearBold />
                            </div>

                            <div>

                              <h5 class="dashboard-box-heading d-flex flex-column">
                                <span className="fs-5 font-weight-bold mb-1">
                                  {detailsState.data.summary.members.renewedMembers}
                                </span>{" "}
                                Membership Renewed This Year
                              </h5>

                            </div>
                          </div>
                        </a>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={() => handleNavigate("/members?status=JoinedThisYear")}>
                        <a href="/members?status=JoinedThisYear" className="d-flex h-100 w-100">
                          <div class="dashboard-box bg-linear-ten">
                            <div class="dashboard-box-icon">
                              <LiaUserPlusSolid />
                            </div>

                            <div>
                              {detailsState.data.summary.members.memberJoinedThisYear > 0 ? (
                                <h5 class="dashboard-box-heading d-flex flex-column">
                                  <span className="fs-5 font-weight-bold mb-1 ">
                                    {detailsState.data.summary.members.memberJoinedThisYear}
                                  </span>{" "}
                                  New Member(s) This Year
                                </h5>
                              ) : (
                                <h5 class="dashboard-box-heading ">
                                  No New Member(s) This Year
                                </h5>
                              )}
                            </div>
                          </div>
                        </a>
                      </Col>
                    </>}
                  </Row>
                </Col>
                {detailsState.data.summary.membersByRole &&
                  <Col xl={4}>
                    <Row className="mt-xl-3 mt-lg-3 mt-md-3 mt-1 px-1 ">
                      <Col xl={12}>

                        <Card className="mb-0">
                          <Card.Body className="p-1 px-3 d-flex flex-column align-items-center">
                            <Col xl={12} lg={12}>
                              <div className="pieContainer center mb-0 ">
                                <div className="pie-wrapper">
                                  <PieChart
                                    animate cursor-pointer
                                    animationDuration={500}
                                    animationEasing="ease-out"
                                    center={[55, 55]}
                                    lengthAngle={360}
                                    lineWidth={40}
                                    paddingAngle={5}
                                    radius={45}
                                    startAngle={0}
                                    viewBoxSize={[110, 110]}
                                    label={({ dataEntry }) => `${dataEntry.value}`}
                                    labelPosition={80}
                                    labelStyle={{
                                      fontSize: '8px',
                                      fill: "#FFFFFA",
                                      fontWeight: 'normal',
                                    }}
                                    data={[
                                      { title: 'Board Members', value: detailsState.data.summary.membersByRole.boardMembers, color: '#a2231d' },  // Lighter green
                                      { title: 'Club President', value: detailsState.data.summary.membersByRole.clubPresident, color: '#169d57' },  // Yellow
                                      { title: 'Club Vice President', value: detailsState.data.summary.membersByRole.clubVicePresident, color: '#000' },  // Yellow
                                      { title: 'Other Members', value: detailsState.data.summary.membersByRole.others, color: '#999' },  // Yellow
                                    ]}
                                    style={{
                                      width: '100%',
                                      height: 'auto',
                                      maxHeight: "200px"
                                    }}
                                  />

                                </div>

                              </div>
                            </Col>
                            <Col xl={12} lg={12}>

                              <div className="overflow-x-auto">

                                <table className="table-auto w-100 mt-6 border-collapse dashboard-members">
                                  <thead>
                                    <tr className="bg-gray-100">
                                      <th className="px-4 py-2 text-left">Member Type</th>
                                      <th className="px-4 py-2 text-left">Count</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr className="border-bottom cursor-pointer animate cursor-pointer" onClick={() => handleClick("role=all")} >
                                      <td className="px-4 py-2 d-flex align-items-center gap-2">
                                      <span class="roundCircle green hide"></span>
                                        <span className="fontItalic">Total Members</span>
                                      </td>
                                      <td className="px-4 py-2">
                                        <span className=""> {detailsState.data.summary.membersByRole.total}</span>
                                      </td>
                                    </tr>
                                    <tr className="border-bottom cursor-pointer animate cursor-pointer" onClick={() => handleClick("role=Board Member")} >
                                    <td className="px-4 py-2 d-flex align-items-center gap-2">
                                      <span class="roundCircle" style={{background:"#a2231d"}}></span>
                                        <span className="fontItalic">Board Members</span>
                                      </td>
                                      <td className="px-4 py-2">
                                        <span className=""> {detailsState.data.summary.membersByRole.boardMembers}</span>
                                      </td>
                                    </tr>
                                    <tr className="border-bottom cursor-pointer animate cursor-pointer" onClick={() => handleClick("role=Club President")} >
                                    <td className="px-4 py-2 d-flex align-items-center gap-2">
                                    <span class="roundCircle" style={{background:"#169d57"}}></span>
                                        <span className="fontItalic">Club President</span>
                                      </td>
                                      <td className="px-4 py-2">
                                        <span className=""> {detailsState.data.summary.membersByRole.clubPresident}</span>
                                      </td>
                                    </tr>
                                    <tr className="border-bottom cursor-pointer animate cursor-pointer" onClick={() => handleClick("role=Club Vice President")} >
                                    <td className="px-4 py-2 d-flex align-items-center gap-2">
                                    <span class="roundCircle" style={{background:"#000"}}></span>
                                        <span className="fontItalic">Club Vice President</span>
                                      </td>
                                      <td className="px-4 py-2">
                                        <span className=""> {detailsState.data.summary.membersByRole.clubVicePresident}</span>
                                      </td>
                                    </tr>
                                    <tr className="border-bottom cursor-pointer animate cursor-pointer" onClick={() => handleClick("role=Member")} >
                                    <td className="px-4 py-2 d-flex align-items-center gap-2">
                                    <span class="roundCircle" style={{background:"#999"}}></span>
                                        <span className="fontItalic">Other Member(s)</span>
                                      </td>
                                      <td className="px-4 py-2">
                                        <span className=""> {detailsState.data.summary.membersByRole.others}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>



                            </Col>

                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>}
              </Row>





            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
}

export default MemberContent;
